import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { globalTripAtom, globalTripDestinationsAtom } from '@/atom/trip';

export function useAiContext(userMessage?: string) {
  const destinations = useAtomValue(globalTripDestinationsAtom);
  const currentSurvey = useAtomValue(globalTripAtom);

  const contextData = useMemo(() => {
    const destinationsForAi = (destinations || []).map((d) => ({
      id: d.id,
      day: d.day,
      poi: {
        name: d.poi?.name,
        latitude: d.poi?.latitude,
        longitude: d.poi?.longitude,
        placeId: d.poi?.placeId,
        poiType: d.poi?.poiType,
      },
    }));

    const currentSurveyForAi = currentSurvey
      ? {
          id: currentSurvey.id,
          cities: (currentSurvey.cities || [])
            .map((c) => {
              if (!c) return null;
              const centerCoords = c.zone?.centerCoords;
              const longitude = Array.isArray(centerCoords) ? centerCoords[0] : null;
              const latitude = Array.isArray(centerCoords) ? centerCoords[1] : null;
              const center =
                typeof latitude === 'number' &&
                Number.isFinite(latitude) &&
                typeof longitude === 'number' &&
                Number.isFinite(longitude)
                  ? { latitude, longitude }
                  : null;
              return center
                ? {
                    id: c.zone?.id ?? c.id,
                    name: c.name,
                    center,
                  }
                : {
                    id: c.zone?.id ?? c.id,
                    name: c.name,
                  };
            })
            .filter((c): c is { id: string; name: string; center?: { latitude: number; longitude: number } } =>
              Boolean(c),
            ),
          companion: currentSurvey.companion?.name,
          fromDateTime: currentSurvey.fromDateTime,
          toDateTime: currentSurvey.toDateTime,
        }
      : null;

    let focusDay: number | undefined;
    if (userMessage) {
      const dayMatch = userMessage.match(/(\d+)\s*일차/);
      if (dayMatch) {
        const day = parseInt(dayMatch[1], 10);
        if (Number.isFinite(day) && day >= 1) {
          focusDay = day;
        }
      }
    }

    return {
      destinations: destinationsForAi,
      currentSurvey: currentSurveyForAi,
      focusDay,
    };
  }, [destinations, currentSurvey, userMessage]);

  return contextData;
}
